import React from "react";
import { useTranslation } from "react-i18next";

import { ButtonColor } from "../../../../components/button/button.constants";
import { simpleDateFromTimestamp } from "../../../../helpers/date";
import { ListDesktopDownloadButton, ListDesktopDownloadIcon } from "../filesToDownload/filesToDownload.styled";
import { downloadCertificate } from "../../../../api/requests";

import {
  Container,
  Cell,
  Icon,
  Title,
} from "./certificateItemDesktop.styled";

export const CertificateItemDesktop = ({ id, passed, validityTimestamp }) => {
  const { t } = useTranslation();
  const date = simpleDateFromTimestamp(validityTimestamp);
  const year = date.slice(6);

  return (
    <Container>
      <Cell>
        <Icon />
        <Title>{t("idd.certificateItemDesktop.year", { year })}</Title>
      </Cell>
      <Cell $withError={!passed}>
        {passed ? t("idd.certificateItemDesktop.passed") : t("idd.certificateItemDesktop.notPassed")}
      </Cell>
      <Cell>{date}</Cell>
      <Cell>
        <ListDesktopDownloadButton
          color={ButtonColor.Primary}
          disabled={!passed}
          onClick={() => downloadCertificate(id)}
        >
          {t("idd.certificateItemDesktop.download")}
          <ListDesktopDownloadIcon />
        </ListDesktopDownloadButton>
      </Cell>
    </Container>
  );
};
